import * as React from 'react';

import { useOfferContext } from '../../../context';
import { getRailwaysTimeToGet, getUndergroundTimeToGet } from '../../../utils/offers';
import { Highway } from 'shared/components/OfferCard/Highway';
import { Railways } from 'shared/components/OfferCard/Railway';
import { Underground } from 'shared/components/OfferCard/Underground';

export const OfferGeoContainer = () => {
  const { offer } = useOfferContext();

  const { geo } = offer;

  const handleClickOfferGeo = React.useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation();
  }, []);

  if (!geo) {
    return null;
  }

  if (geo.undergrounds?.length) {
    const underground = geo.undergrounds[0];
    const { name, qs, lineColor, underConstruction } = underground;
    const time = getUndergroundTimeToGet(underground);
    const regionId = geo?.address ? geo.address[0]?.id : undefined;

    return (
      <Underground
        regionId={regionId || 1}
        time={time}
        name={name}
        lineColor={lineColor}
        searchUrl={qs}
        underConstruction={underConstruction}
        onClick={e => handleClickOfferGeo(e)}
      />
    );
  }

  if (geo.highways?.length) {
    return <Highway highway={geo.highways[0]} onClick={e => handleClickOfferGeo(e)} />;
  }

  if (geo.railways?.length) {
    const railway = geo.railways[0];
    const time = getRailwaysTimeToGet(railway);

    return <Railways name={railway.name || ''} time={time} />;
  }

  return null;
};
